import { Card, CardHeader } from '../../../components/Card.jsx'
import { Tile, BarList, MethodNote, fmtNum } from '../ui.jsx'

/**
 * National Screening Analytics — routine medical screening activity and
 * outcomes across all campaigns and employers. Fitness-for-work outcome
 * mix, delivery modes, and campaign status. k=5 privacy floor per bucket.
 */
export default function ScreeningAnalytics({ data, windowDays }) {
  const sc = data.screening || {}

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader
          title="National screening analytics"
          subtitle="Routine medical screening delivered across every participating organisation — campaigns, throughput and fitness-for-work outcomes."
          right={
            <span className="text-[10px] uppercase tracking-wide border rounded-full px-2 py-0.5 bg-violet-50 text-violet-700 border-violet-200">
              screening
            </span>
          }
        />
        <MethodNote>
          Counts routine-screening campaigns and the people screened, plus
          fitness-for-work outcomes and delivery modes. Outcome and mode buckets
          below 5 are hidden (k=5 floor).
        </MethodNote>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          <Tile label="Campaigns" value={fmtNum(sc.campaigns_total)} colour="wantok" />
          <Tile label="Active campaigns" value={fmtNum(sc.campaigns_active)} colour="emerald" />
          <Tile label="People screened" value={fmtNum(sc.records_total)} colour="sky" />
          <Tile label={`Screened · ${windowDays}d`} value={fmtNum(sc.records_window)} colour="indigo" />
          <Tile
            label="Significant findings"
            value={fmtNum(sc.significant_conditions)}
            sublabel="flagged conditions"
            colour="rose"
          />
        </div>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card>
          <CardHeader title="Fitness-for-work outcomes" subtitle="Across all reviewed screenings." />
          <BarList items={sc.fitness_outcomes} colour="emerald" />
        </Card>
        <Card>
          <CardHeader title="Delivery mode" subtitle="How screening was delivered." />
          <BarList items={sc.by_delivery_mode} colour="violet" />
        </Card>
        <Card>
          <CardHeader title="Campaign status" subtitle="Lifecycle stage of all campaigns." />
          <BarList items={sc.campaigns_by_status} colour="sky" />
        </Card>
      </div>
    </div>
  )
}
